import { render, staticRenderFns } from "./Upscaling.vue?vue&type=template&id=1f0c0ea8&scoped=true"
import script from "./Upscaling.vue?vue&type=script&lang=js"
export * from "./Upscaling.vue?vue&type=script&lang=js"
import style0 from "./Upscaling.vue?vue&type=style&index=0&id=1f0c0ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c0ea8",
  null
  
)

export default component.exports